import React, { useEffect, useState } from 'react'
import { TbBeachOff } from "react-icons/tb";
import { fetchAllDataAPI } from '../../utils/api';
import moment from 'moment';
import withAuth from '../../utils/withAuth';

const HolidayEvent = () => {
    const [holiday, setHoliday] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        getAllHolidayThisYear()
    }, []);

    const getAllHolidayThisYear = () => {
        setIsLoading(true);
        fetchAllDataAPI('hr-all-holiday-this-year').then((res) => {
            if (res.data.status === 1) {
                setHoliday(res.data.holiday || []);
            } else {
                setHoliday([]);
            }
            setIsLoading(false);
        }).catch(() => {
            setIsLoading(false);
        });
    }

    const renderSkeleton = () => {
        return Array(5).fill(0).map((_, index) => (
            <div className="eventholiday d-flex justify-between align-items-center border-top border-bottom p-2" key={index}>
                <div className="ms-2 upcomingbirthdayname">
                    <div className="skeleton skeleton-text w-75 mb-2"></div>
                </div>
                <div className="upcomingbirthdaydate">
                    <div className="skeleton skeleton-text w-50"></div>
                </div>
            </div>
        ));
    }

    const renderNoDataFound = () => {
        return (
            <div className="text-center py-4">
                <p className="text-secondary mb-0">🏖️ No Holidays or Events Found!</p>
            </div>
        );
    }

    return (
        <div className="holidayeventsection card-body card radius-10 overflow-hidden w-100 topsection">
            <div className="eventholidaytitle d-flex justify-between align-items-center">
                <div className="title">
                    <h5 className="mb-0">Holidays and Events</h5>
                </div>
                <div className="icons">
                    <TbBeachOff />
                </div>
            </div>

            <div className="p-2 ps ps--active-y bodysection">
                {isLoading ? (
                    renderSkeleton()
                ) : (
                    holiday.length > 0 ? (
                        holiday.map((holidayItem, index) => (
                            <div className="eventholiday d-flex justify-between align-items-center border-top border-bottom p-2" key={index}>
                                <div className="ms-2 upcomingbirthdayname">
                                    <h6 className="mb-1 font-14">{holidayItem?.holiday_name}</h6>
                                </div>
                                <div className="upcomingbirthdaydate">
                                    <span>{moment(holidayItem?.holiday_date).format('Do MMM YYYY')}</span>
                                </div>
                            </div>
                        ))
                    ) : (
                        renderNoDataFound()
                    )
                )}
            </div>

            {/* Skeleton Style */}
            <style jsx="true">{`
                .skeleton {
                    background-color: #e2e2e2;
                    border-radius: 4px;
                    animation: shimmer 1.5s infinite linear;
                }
                .skeleton-text {
                    height: 12px;
                    margin-bottom: 8px;
                    border-radius: 4px;
                }
                @keyframes shimmer {
                    0% { background-position: -400px 0; }
                    100% { background-position: 400px 0; }
                }
            `}</style>
        </div>
    )
}

export default withAuth(HolidayEvent)
